export function smoothScrollTo(targetY, duration = 800) {
  const startY = window.scrollY;
  const difference = targetY - startY;
  let startTime = null;

  function step(timestamp) {
    if (!startTime) startTime = timestamp;
    const progress = timestamp - startTime;
    const percentage = Math.min(progress / duration, 1);

    // Easing function: easeInOutCubic
    const easing = percentage < 0.5
      ? 4 * percentage * percentage * percentage
      : 1 - Math.pow(-2 * percentage + 2, 3) / 2;

    window.scrollTo(0, startY + difference * easing);

    if (progress < duration) {
      window.requestAnimationFrame(step);
    }
  }

  window.requestAnimationFrame(step);
}

export function scrollToSection(id, duration = 800) {
  const el = document.getElementById(id);
  if (!el) return;
  const navbarHeight = 72;
  const top = el.getBoundingClientRect().top + window.scrollY - navbarHeight;
  
  if (duration === "smooth") {
    window.scrollTo({ top, behavior: "smooth" });
  } else {
    smoothScrollTo(top, duration);
  }
}
